module.exports = "/_next/static/videos/golf-1-6febb484a77c8c12abd18b4e74e00315.webm";